export default __webpack_public_path__ + "static/media/fox coin.cc66f0b9.svg";